module.exports = __webpack_public_path__ + "static/media/logo.e929f539.svg";